import { Mail, Instagram, Heart } from "lucide-react";
import { LINKS, IMAGES } from "@/data/site";

export const Footer = () => {
  return (
    <footer
      id="contact"
      className="relative z-10 bg-[#2B2D42] text-white py-20 lg:py-28"
      data-testid="footer"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-12 items-start">
          <div>
            <p className="text-xs tracking-[0.3em] uppercase font-medium text-[#F2CC8F] mb-6">
              Contact
            </p>
            <h2 className="font-display text-4xl sm:text-5xl font-bold leading-tight tracking-tight">
              Let’s build a kinder world together.
            </h2>
            <div className="mt-10 flex flex-col gap-4">
              <a
                href={`mailto:${LINKS.email}`}
                data-testid="footer-email"
                className="group inline-flex items-center gap-3 text-lg text-white/90 hover:text-[#F2CC8F] transition-colors"
              >
                <span className="inline-flex h-11 w-11 items-center justify-center rounded-full bg-white/10 group-hover:bg-[#E07A5F] transition-colors">
                  <Mail className="h-5 w-5" />
                </span>
                {LINKS.email}
              </a>
              <a
                href={LINKS.instagram}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-instagram"
                className="group inline-flex items-center gap-3 text-lg text-white/90 hover:text-[#F2CC8F] transition-colors"
              >
                <span className="inline-flex h-11 w-11 items-center justify-center rounded-full bg-white/10 group-hover:bg-[#E07A5F] transition-colors">
                  <Instagram className="h-5 w-5" />
                </span>
                DM @haven_for_tails
              </a>
            </div>
          </div>

          <div className="lg:justify-self-end">
            <div className="flex items-center gap-4">
              <span className="h-16 w-16 rounded-full overflow-hidden ring-2 ring-white/20 bg-white shrink-0">
                <img
                  src={IMAGES.logo}
                  alt="Haven For Tails"
                  className="h-full w-full object-cover scale-[1.18]"
                />
              </span>
              <div>
                <p className="font-display text-2xl font-bold">Haven For Tails</p>
                <p className="text-white/60 text-sm">Love for all animals</p>
              </div>
            </div>
            <a
              href={LINKS.gofundme}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-donate-btn"
              className="mt-8 inline-flex items-center gap-2 rounded-full bg-[#E07A5F] px-7 py-3.5 font-semibold text-white transition-all hover:bg-[#D06A4F] active:scale-95"
            >
              <Heart className="h-4 w-4 fill-white" /> Donate on GoFundMe
            </a>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-white/10 flex flex-col sm:flex-row justify-between gap-4 text-sm text-white/50">
          <p>© {new Date().getFullYear()} Haven For Tails. A youth-led nonprofit.</p>
          <a href="/admin" className="hover:text-white/80 transition-colors" data-testid="footer-admin-link">
            Officer Login
          </a>
        </div>
      </div>
    </footer>
  );
};
